module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch1"
    }
  }, [_vm._v("ACT ONE")]), _vm._v(" "), _c('p', {
    staticClass: "cst1"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sound of surf.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sings")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Gone sing ’bout that man because his stories please us,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Who saw trials and tempests for ten years after Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m Blind Billy Blue, my main man’s sea-smart Odysseus,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Who the God of the Sea drove crazy and tried to destroy.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Andra moi ennepe mousa polutropon hos mala polla …")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("The shuttle of the sea moves back and forth on this line,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All night, like the surf, she shuttles and doesn’t fall")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Asleep, then her rosy fingers at dawn unstitch the design.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When you hear this chord")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chord")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                              Look for a swallow’s wings,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("A swallow arrowing seaward like a messenger")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Passing smoke-blue islands, happy that the kings")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Of Troy are going home and its ten years’ siege is over.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So my blues drifts like smoke from the fire of that war,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Cause once Achilles was ashes, things sure fell apart.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Slow-striding Achilles, who put the hex on Hector")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A swallow twitters in Troy. That’s where we start.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Exit.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE I")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Troy. Dusk. Heavy smoke. The kings,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON, MENELAUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("with")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("the mercenary, pile weapons on a pyre. Drums.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Pile our worn weapons on this remembering cairn.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Till salt air rusts them, till they’re wrapped in veils of sand.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Turn the gaping beaks of our fleet homeward again.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Since Troy is a plain of ashes where kites ascend.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Till men ask ‘Was it here?’ of the gliding frigate.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("‘Was it here that their lances pinned Achilles’ pyre?’")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who rattles his angry lance along heaven’s gate.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Through the length of war, home was our long desire.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It was mine, Menelaus, whose wife was its cause.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And mine, Ajax, the heir of Achilles’ armour.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters at a distance.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Not mine, Thersites. No wife, no son, no house.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And ingenious Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                            And mine, Nestor.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pause. A swallow twitters overhead. They look up.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That swallow’s eager to leave. Where’s Odysseus?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In his tent, checking his tribute.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                       Once more, we wait.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("steps forward, eating.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We’re piling gifts on Achilles’ mound. Any size.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("pays his small tribute.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There. I couldn’t choose what to give. Sorry I’m late.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("O lucky dead, who can’t tell friends from enemies!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Agamemnon denied you flame-haired Briseis.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Menelaus mocked you: ‘Deliverer from Mice’.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now all your glories are reflected in their eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This scrolled shield Hephaestus hammered, who is its heir?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He holds up a shield.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He willed it to Odysseus on the battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Achilles was fitful. He promised me first.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                       Where?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look, two claims injure his spirit! You take the shield.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, no, you take it, Ajax, you fought the hardest.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You heard me say that? Did I ever make that boast?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("For God’s sake, it’s his burial mound. Let him rest.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He gives")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("the shield.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bear it, you turtle! Take ten years to reach your coast.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now let the coiled rams’ horns moan with our departure.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let the eagle’s pennon steer us through the cloud’s foam.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Horns and drums.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let these pennons tatter after ten years of war.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let wet-heeled Athena race our lunging ships home.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Exit except")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("who retrieves more souvenirs from the mound.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So. We’re naked men again. Our armour is shelled.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes. Home to the fig tree’s shade, the wine press, the farm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Hang it on a hook, but cries will ring from that shield.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How’ll you live?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                            This old war-dog? Off scraps of fame.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You regret victory, Thersites. I know why.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yeah? Then you make my dissatisfaction exact.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("After victory what?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 Peace. Screw peace. No money.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Peace ruins mercenaries.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           No? I’ll note the fact.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It loosens the bonds of war. That’s what you’re feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And of course you think you know what my unrest is.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A warm white back curled against you. Your own ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The sky is my roof. This sword sleeps with Thersites.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Get a son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 And a dog. And a blooming garden.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Come to Ithaca.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                            Can you promise me a war?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. Hang your sword on a hook.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                         What? Hang my own wife?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Our ribbed bodies long for their original shore.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Except this body. That’s found no shore to believe.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Lend me your wife, your sword. Here’s my will, Thersites.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("gives his sword to")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("who draws on the sand.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My white ribs, a harp that the sea-crab’s fingers pluck.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My shoal-pebbled island, too stony for horses.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Except Thersites loves horses. His usual luck.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I bequeath him Mount Neriton’s marching poplars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’d tell them to halt, man. Trees spread peace. I decline.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’d rule next to me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      I’d piss on the populace.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("draws on the sand.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Take my hunting dog, Argus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                   That’s it! I resign.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          Hate dogs. Slobberers. Dumb pain, dumb affection.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Open the gates of those locked teeth. Admit love, friend.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ll say it with grinding jaw. I loved you. Go on.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They embrace, then exit in opposite directions.")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A distant roar, growing. Banners, masts.")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then, as the slow forest of Greek masts began sailing,")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A long cry of a bird or woman.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("They heard the wide cry of a woman or frigate bird …")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And that cry lanced their hearts for all that it augured:")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Over the stones of her children, Hecuba wailing.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A funeral cry like a torn cloth, then a huge hum,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The wings of flapping standards unfurling like cranes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHORUS OF ARMIES")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Off")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ranks and divisions, hoist our banners for home!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like cranes that darken the sky before winter rains")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHORUS OF ARMIES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The bones of our comrades rattle like dice on this shore.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ranks from Pylos, divisions from Ida, shapely men.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their white ribs hoisting the black sail of the vulture.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHORUS OF ARMIES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Divisions from Aspledon, ranks of poplars fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then, a sail, for ten years crawling on the sea’s line.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE II")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ithaca, ten years later.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("seated, is staring at another chair.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters with wine, waits.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A swallow spoke to me from the wrist of that chair.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You send for wine? What happen to your sea captain?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The elect can take natural shapes, Eurycleia.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Lord, bird t’ief this boy’s wits.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                   It twittered, ‘He’ll return.’")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("These thoughts is like straw, whirling around your father.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The whirr of one swallow starts destruction’s engine.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("An’ this nest empty. This house that he should be in.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You said Athena, the sea-eyed, is Egyptian.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But never in life me call any bird captain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She said she’d argued with God to save my father.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nancy stories me tell you and Hodysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I believe them now. My faith has caught a fever.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Launching your lickle cradles into dreaming seas.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What were those stories? An old slave’s superstition?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("People don’t credit them now. Them too civilize.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It had a girl’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughing")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 A girl? So that’s your distraction!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("         A girl make sense. But when bird mater’alize …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He was trim and bearded and far too young for Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Troy old as you, Telemachus. Twenty years’ pain!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s here, Eurycleia!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                    I old. Don’t mock me, boy!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Believe me!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    My faith gone. It can’t come back again.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To me and my father you have been slave and nurse.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes. Is Egypt who cradle Greece till Greece mature.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then why doubt the goddess now in a swallow’s noise?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, if that bird was your captain, make him stand there.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A sea captain,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your faith has returned.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("turns.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         Forgive my sins, sir. You is?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your sins are so far back God has forgotten them.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Eurycleia. Me raise both boys.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                    This is Captain Mentes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I swam Troy’s smoke with his father, that clouded time.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why you come only now?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                              Because he’s in danger.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This boy come of age. Them suitors don’t want no heir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Strange things may happen here, but there will be stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A swallow has lanced us with light, Eurycleia.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I looking at God and can’t remember my sins.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I turned my back. We were talking. Then you weren’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I went to the window. My ship is loading bronze.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A roar from the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You can hear for yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             What’s all the feasting for?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What else? My mother’s marriage and my father’s wake.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They go spew like vomit through the gorge of that door.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ve come of age. You know what you must undertake.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A hundred boars jostling to nose his mother’s trough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Grunting and shoving till she finishes her shroud.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is a hundred in there, Captain. Plenty enough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My father is lost. My faith has entered a cloud.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’ll fix them. His bow-string humming like a swallow.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I can’t leave my mother with them. It isn’t right.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look, the day she chooses, you die. You must leave now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She will choose one.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                   Then he’ll murder you one night.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Enter drunken")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(" — "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS, EURYMACHUS, AMPHINOMUS, CTESIPPUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LEODES")]), _vm._v(" — "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("dragging")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MAIDS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("with them.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s the boy doing here? This stuff’s not for you, lad!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A food fight, they pelt")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We’ll keep doing this till we hear from your mother.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who’s your friend?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They crowd")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENTES")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 Can’t you see the kid’s missing his dad?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your dad’s dead. You’ll choose one of us for another.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why are they suddenly quiet?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                    For my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("draw back, stumbling. Light from an open door.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("veiled, crosses.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They part like hills for a sail entering harbour.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They are stunned by her passage each time she appears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She begging the poet to stop praising the war.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("jostle, crowding")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aim for my heart! Arch that white arm!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                     It’s been three years.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not Leodes. His sex is soft wax. It’d dissolve!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LEODES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not vain Ctesippus, plucking his brows in mirrors!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Little shrimp prick!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LEODES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                   His own face is all he can love.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Unveil the shrine of that brow to its worshippers!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Those eyes, black olives, that forehead whose marble stuns!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("unveils her face.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her smile is like the sunlight edging a window.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Till it brightens Antinous, her favoured prince.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE, BILLY BLUE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MAIDS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("except")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exit.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("crosses to the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I mourned my father’s absence. Soon I’ll avenge it!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Such sweet impetuosity, Telemachus!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There’s a hundred of us, boy. How will you manage it?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Pigs! From today you will stop uprooting my house!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exit.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Steer for the wide sands of Pylos. Look for Nestor.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Right now?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   Next, Sparta. Find red-haired Menelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Those are two long journeys, Captain. What’s the quest for?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Do you want your father’s shadow to cross this house?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("God!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("         I’ve twenty oarsmen waiting, hunched on their oars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("One for each year I’ve missed him. Manning whose vessel?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A beaked yellow ship, like a hawk? Antinous’.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You seized it?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                        Borrowed it. Well, it was there to seize.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And it’s fitted?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         With amphora of ground barley.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All right. So I get to Pylos. What next once I’m there?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Assemble the elders. Demand a big parley.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Those old men love quarrelling. Bunch of rattling sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The cord of your voice must bind those sticks together.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I envy my father’s authority.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                 Or tricks.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tricks?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            I too saw the wooden horse blocking the stars.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You see?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("               Troy fell for it.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                        Was he that brilliant?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A horse foaling men? They thought it ridiculous.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Him could convince a grasshopper it was a ant.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look there! A swallow trying to get through the roof!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Me don’t see it. Now where him gone? How that happen?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He was Athena! Do you need any more proof?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("      Then I’ll follow the winged heels of my captain.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He exits.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("returns, attended by")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("who whispers in")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("’s ear.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who told you to stay so close to me, Melantho?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Because Melantho have ambitions of her own.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ambitions?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    Madame, it have things that you don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You can have my sorrow, Melantho, with my throne.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t want your throne, she’s lying. Eurycleia!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look, girl, there are ways of putting your fire out.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You didn’t boast to me in the kitchen?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                  Liar!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That some prince in there go marry you?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                             LIES!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                       DON’T SHOUT!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Madame …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                     He left with this stranger? Are you crazy?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Some shining young captain was here who fought at Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Stay in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 Not for long. Please excuse me.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She exits, brushing past")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(". "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A burst of song from the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SUITORS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Madame, him is of age, him no longer a boy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The bloody war’s over. Can’t they sing something else?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Him gone and pack him things.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Pack his things? He’s gone? Where?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("God, whatever we suffer we bring on we selves!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Talk!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("         Some swallow talk to him, then it disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Swallow? Old woman, you want my palm on your face?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Hit me, go on.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         Why not tell me he was leaving?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She embraces")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Melantho who tell you. She is always the first.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Melantho helps me to unravel my weaving.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("True.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("         We fold his clothes in camphor. Unoccupied.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So long in their press, them fit Telemachus now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ve knelt by our olive-tree bed, I’ve prayed and prayed.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But him knew you would last.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                    How in hell could he know?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Mistress, is strong-timbered virtues uphold this house.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Till my patience cracks and it plunges in chaos.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Because none in there can match the husband you choose.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes, choose and then lose him. Who next? Telemachus?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She breaks down.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not now, Eumaeus, a family crisis here.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Since when am I excluded from this family?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Back to the kitchen, old man.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                   I brought the order.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Eumaeus, listen! My one son has left this house.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where’s he gone, Mistress?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         Why you don’t mind your business?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’s her business, fifty hogs and fifty prime sows.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("       The stock’s running out at a rate. Now this news.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Eumaeus, you believe the Master’s safe, don’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Safe? ‘Fine day,’ I thought, goading pigs up the white road.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Say he’s safe, Eumaeus. Now my son has gone, too.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their trotters dancing. Happy at being slaughtered.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("shows")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("out.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He dotes on Odysseus. That’s the weight he bears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Him old, but take good care of the stock all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They raced by rivers together, hunting wild boars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His ears does prick like the dog at Odysseus’ name.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Does your son believe he’s the master of this house?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He is. He’s of age.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                              He shouted at your suitors.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Dat is him right, sar! His father still Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("SHUT UP!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _vm._v(") See how a servant talks in front of us?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She is this house’s foundation. She was his nurse.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, her dugs are dry now.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(")                       Listen, you! No more noise!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("‘If I die, marry,’ he said, and sloped to his wars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To lead an army of shadows. Death is his bride.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When you prove my divorce, I’ll follow his orders.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ord-ysseus is lost since Troy, his wish disobeyed.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re the great pine above those suppliant princes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ve made a hundred men think they’re like no one else.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll soon win your siege. I’ve run out of devices.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then that wall is down that you built between ourselves?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The wall has cracks in its face.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                    Bend that proud neck. Nod.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A nod could be final.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     Let one nod finish me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Another dead husband?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                          One nod is all I need.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To die?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            For one arrow from those eyes? Happily.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t punish me, sir, but I have serious news.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Better make it good, girl, or I’ll lop off that nose.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The boy has gone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                               Melantho!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                 Gone? Telemachus?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look in the harbour. He stole your ship, Antinous.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Poor girl! You were the last jewel left of my trust.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There was some sea captain here. You know who he was?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He grabs")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Me no see no sea cap’n, sir! Leggo me wrist!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("releases")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s been unravelling the same shroud for three years.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ah! I understand. Call in the others. Right now!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You touch my son and you’ll face my husband’s revenge.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your husband is dead. What sword can slice a shadow?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("      Let him return. He’ll see how your patience ends.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My patience wasn’t slavery, it was pure trust.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And mine for three years. Get our marriage bed ready.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look, sir, my vows aren’t brooches I wear till they rust.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Neither is my star, that’s kept its distance, lady.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enter, armed.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The girl told us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                            Arm two fast vessels!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                 There’s no wind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("If you lose him, hide in some cranny of the coast.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Right!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Post sentinels on the crags of each island.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’ll roost till they turn into eagles, Antinous!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Very odd! He’s never acted this way before.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, with this ambush he won’t act this way after.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He was simply sullen, until this visitor.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then this island is ours. No more son, no father!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMPHINOMUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTESIPPUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exit.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("If he dies your stubbornness put him in the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You think I’d step over his grave into your arms?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’d rather not kill him. But if that’s what you’re worth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ll bend when the bow bends.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                     What bow?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                         The one that aims.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Points at his heart.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re like some olive tree, waiting for her shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And you would wrench her last leaves: son, Eurycleia.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That hot blue sea stays empty. That sail you pine for.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Its line is my bow-string, and its waves my lyre.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Me lost a husband too. Him was a damn scoundrel.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Eurycleia!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                  But me miss the scamp all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My hope is like a little lamp on a black hill.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes, and when night coming down, is the worse, madam.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Our bed is white and quiet. It’s smooth with silence.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Me know how linen keep still when somebody die.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His shadow slides on my wall. I feel his presence.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, ma’am!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    I turn, and my glance makes his shadow fly.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They exit. Shadows of crossing oars, increasing speed.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHORUS OF OARSMEN")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chanting off")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ayis! Do-o! Trayis! Tetra! Pente! Ex!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ayis! Do-o! Trayis! Tetra! Pente! Ex!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sings")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A one, a two, a three, four, five, six goes the mattock")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Of the boatswain as the oarsmen bend their necks")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Racing like mullet from the shadow of a sea-hawk.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Ayis! Do-o! Trayis! Tetra! Pente! Ex!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So mowers will increase the circle of their scythes,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Flailing at the waves of grass bowing from the wind")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So the long blades of the rowers race for their lives")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Towards Pylos, past Samos, leaving their hunters behind")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who spin back like sea-hawks, tired of the chase,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The oars fanned towards Pylos, then closed near Nestor’s palace.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE III")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nestor’s palace. Interior.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("waiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You got here fast. Been to Temesa already?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A following wind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                               Struck a good deal with the bronze?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The bronze? Oh, the bronze! Let’s say the wind was steady.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wasn’t your cargo iron?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         What’s the difference?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Athena …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                  Wait. Your hunters, what happened to them?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They got tired like hawks. We cheered, watching them turn.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You had twenty great oarsmen.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                      Like scythes in rhythm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Those hawks will hover in inlets for your return.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters, with")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATTENDANTS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is this Nestor? That aged?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                            Surf-haired. He always was.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I cracked brine-seasoned whips over foaming horses.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sir, Captain Mentes. This prince is Telemachus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He enraged the sea, your father, Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The sea’s a maw that devours.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                  A god who saves.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He saved you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                        To his shame, image of Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("From Poseidon’s charging herd, the unbridled waves.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No whip dipped in brine can steer the sea’s white horses.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The sea’s ungovernable, is that what you mean?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Does he love questions? Another Odysseus!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sir …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Young Odysseus! You finish what I mean!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where’s my father? Each dusk the sea-swallow steers home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There’s brilliance in here.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Your eyes, watering. The glare.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("peers at")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENTES")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. Like when your bright feet, Athena, skim the foam.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m Captain Mentes, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         No. The clouds’ messenger.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When was that, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  At Troy. A swallow twittering.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That was when you last saw my father. Is that right?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We looked up, unhelmeted, every blood-grimed king.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All of Troy’s sorrow is borne in a swallow’s flight.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ten years! And my heart is stabbed by a bird’s twitter.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Kites cried there, and ravens, the sky one black complaint.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her voice was as close as yours.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                      Why, does it matter?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes. Athena was that swallow’s inhabitant.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In my small harbour harp songs ripple the water.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With heavy sadness.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                   An anchor.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                      Troy’s kings are home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their feet are washed by servants. There’s wine, and laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His mother smooths the white sheets, then kneels there for him.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I crashed like a horse in surf, felled by exhaustion.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All the tired kings.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                The bed heaving.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                              Not my father.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You may have lost your father. But he’s lost a son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, where’s he, my shipmate? His ship! Cyclones toss it.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’ll turn up.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                     Keel upward.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                            Our fleet melted in rain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sir …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           That sea’s so wide birds take a year to cross it.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nestor, I’m sorry that I cause you so much pain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Odysseus’ prow dolphined over black combers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Does he still remember every ornate detail?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His mind will cloud soon, and then he disremembers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I watched the snail’s silver of his diminished sail.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He scorned the sea, that is the last irreverence.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your father reduced to reason every omen.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He defied the sea, where no force can pitch its tents.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Spray spat on great Agamemnon, that king of men.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Two silvery currents fork that sea. He turned left.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your father turned right.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Apparently right was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It trembled on the world’s rim, far from those he loved.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s tired now. He shouldn’t have spoken this long.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Across the ungirdered sea, the sky’s foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where the sea-wall has measured its dividing line.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Through twisted pillars of rainspouts his bright wake shone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Still, all of his old friends pray for his long return.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The ship crawled like a fly up the wall of the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And then?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                  Then, I suppose, it fell over the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And vanished, for good?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Or evil, evidently.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Through this world’s pillars, the gate of human knowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s not the surf. He gets tired of his own speech.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The shame I feel for Odysseus, because I’m home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He would forgive you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      His mind’s a sea-mist now. Come.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Aside to")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENTES")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What have I learned from this foam-haired philosopher?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What the young should learn. Patience.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                     He’s told me nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You heard what the young need to hear: old men suffer.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t disappear again, Captain. Where’re you going?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                     Give him a chariot. The finest.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bless you, Nestor.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         Where’s your friend?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                              Blessings on your house.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST ATTENDANT")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sit by your old blue window and watch the waves rust.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Gallop to Sparta and question Menelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He is led off.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("mounts the chariot. Actors mime two horses. They exit. Enter")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sings")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("On the pebble road through undulant Lacedaemon,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Like a young Nestor, he urges the chariot on.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then the horses rear, at the sight of another omen.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("At the sight of another omen, the horses rear,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nearly pitching the boy, who saw Athena’s omen")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("As an eagle hurtled and snatched a trembling hare.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then the horses raced their long shadows over again,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Huts lit their lamps on the hills and the ways darkened.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The sun fell down like a tower on Troy’s black plain,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("The stars’ candles fluttered but didn’t go out in the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So haya! he cries, haya! to the frothing horses.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("The starlight shines on their sweating flanks, their heads")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Plunging like porpoises, until he saw the torches")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("From the palace of Menelaus, all the kings of Troy in their beds.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE IV")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sparta. Menelaus’ palace.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("kneels.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I bring you Nestor’s regards. He gave me his whip.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ah, Nestor! How is Nestor? Great charioteer.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tired.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          Nestor. A foaming beard near a black ship.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He mourns his son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  I know. None knew our fates, back there.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But isn’t home God’s bounty, great Menelaus?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. God’s trial. We earn home, like everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Still, you’re back home, with your wife, in a great palace.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All heaven’s treasury cannot ransom my loss.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What loss?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   They butchered my brother, Agamemnon.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                A cunning lover. A treacherous wife.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          I leap up, drenched in cold sweat, I hear him moan.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("God!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("         The net of his red veins fraying from the knife.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Horrible.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                That enough fortune? For the jealous?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No man should envy your wealth, poor Menelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Some heartless shadow stalks the House of Atreus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But love could frighten it, and sunlight flood your house.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes. The cause and cloud of Troy will sail through that door.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m Helen. Or I used to be. You’re most welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is staring.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I understand all. Sorry. You confirm a wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ohh …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v2"
  }, [_vm._v("             Spears should surround her, not servants. But she’s home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I had no idea he had such a strapping boy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Odysseus has spent ten years without coming home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, at least he’s travelling.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                She’s bored. She misses Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I do "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not")]), _vm._v(" miss Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 Miss being its centre. Its cause.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t I look quite happy to you?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                        Think he’ll say no?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("‘Miss Troy’! That’s a stupid remark, Menelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sorry, dear.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    Men. They’ll blame me for everything now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t think he came here to watch us bickering.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The whole thing was not over me but some sea-tax.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh? Your memory’s fading like your hair dye, darling.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Did I say I missed Troy? You and your cheap attacks.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s a hard time sleeping. She remembers it all.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There’s an Egyptian herb that my mother uses.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She leaps up. Torches on the water. The black wall.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She caused much pain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                        Including yours for Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Do you think he’s dead?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                          Too smart. Too acquisitive.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But did he ever take bounty he’d never earned?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughs")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That sacker of cities? He’d say, ‘Kings have to live.’")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He did well from the war?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             For him that’s why Troy burned.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Surely that wasn’t all?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      It meant more than the war.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Outright pillaging?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  Like the shield, he took his share.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He sounds like a rug-seller, not a warrior.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, he’s coming back well-loaded, you can be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What else?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   He loved to eat. Enormous appetite!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He laughs.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What did he like?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                               Like? Anything. Ate like a goat.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m embarrassed.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                              His motto was ‘First eat, then fight.’")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What would you do?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     We’d eat. Even Ajax the Great.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters, pushing a golden cart on silver wheels. She sits some distance off and weaves.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("rises.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’ll sit there quietly. Nothing will distract her.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She cracked the horizon’s heart like any other.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now she’s quiet marble, with light for her sculptor.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Only the sea-breeze stirring the fringe of her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A flawed vase, now sealed, redeemed by its collector.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("One that sighs sometimes at the hollowness of war.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But she’s a good wife again. A perfect mother.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Turns to")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I know you’re thinking, was all Troy’s turmoil worth her?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To bring her home? All that chaos? What’s your answer?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It was.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           I have a theory about your father.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The wool, please.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("picks up the wool, hands it to")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                              Whatever helps twenty years of love.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Seals. Fog. And an old man, changing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                            Smile. You weren’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Show him the figured vase now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                       Watch this. He’ll dissolve.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SERVANT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters with a vase, exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your sail’s way ahead of mine, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                          It always is.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I see fog. An old man, creeping. What does it mean?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Forgive me your pain, image of Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I do.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("        Look, the wine-dark sea, veined aquamarine.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go on.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            Can you knot the mist? Cup fog in your hand?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And this figure sprang from the sea in different shapes?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He scuttled crab-wise from the surf, burrowing in sand.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who is he?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   Proteus. He’s fluent. He escapes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This is my old nurse’s tale, great Menelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then consider yourself forever in her debt.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          The gates of imagination never close.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Even in grown men?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                    What are men? Children who doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go on.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Dawn. The Nile’s mouth, exhaling. Barking seals.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Seals bark. Fog.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Points")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your ship?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                  Blown months off course by a remorseless wind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then, through fog, this crawls?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                      Net-slinger, he catches souls.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You think he’s caught my father’s?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                           It has crossed my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Men aren’t crabs, Menelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                We hid in seal-skins.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My father is alive, alive. He’s lost, that’s all.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That crooked old man. I wrestled him with questions.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like what, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         Under stinking seal-skins. We kept still.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("While the fog shaped these? A snake, a cloudy lion?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Shh. Creeping. A crab. Sand-wise. Testing the foam.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, I see him! Through that net of spray. What question?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What my prayers urged me. The soul’s question. Which way home?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROTEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears. He wrestles with")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROTEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in the fog.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROTEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("points.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("follows his direction.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("sits alone. Torches go out. The vase begins to whirl, with the loud sound of water.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("rises, walks down to the morning beach.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("ECHO ME, ISLANDS! ODYS-SEUS! ODYSEE …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ECHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                   SEA, SEA, SEA … ODYSEEEE …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I WANT TO SEE YOU, FATHER!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ECHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                           FARTHER,")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                               FARTHER …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("CARRY MY CRY THROUGH YOUR CAVES!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ECHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                                CAVES!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("PAST VOLISSOS, CHIOS, DELOS, ITHACA …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ECHO")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                                   CARE!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("sits on the sand.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Help him to wrestle the weed-bearded waves …")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Surf, sibilance.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE V")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Odysseus’ ship, being loaded.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILORS STRATIS, COSTA, STAVROS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("chanting.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILORS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Get a load of this, boys, handle with care")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Gifts our cap’n’s bringing home from Troy to Ithaca.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bales from cities that he sacked on his way home,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Gifts from King Aeolus, maybe he’ll spare some.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In my mountains, snow. March dreaming of October.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’s mis’rible there. The mountains. Pissing with rain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who’s warming the wife, Stavros? Ramming it to her?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("draws a knife. A scuffle.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("intervenes.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My wife good woman.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                       Save the knife for our captain.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He takes the knife. Loading continues.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wonder what stories our captain pitched to the king?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Enough for these gifts to weigh down her water line.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Done all right by the war, din’t he? Looting, sacking.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s why he’s ‘Sacker of Cities’. You’ll never learn.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bounty from Troy! See that, Stavros? Widen your eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s your salary? Salt. Live off that forever!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A huge bag is shipped aboard.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Here’s that bag the king gave Captain Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aeolus rules this island but not its weather.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He wants to get home, but stops off to plunder cities?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Leaving their coasts smoking with his anger. The Great!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Just like you, shepherd, he has faith in his missis.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s making sure old age isn’t singed with regret.")]), _vm._v(" "), _c('p', {
    staticClass: "exvs"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They stow the bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Upper deck. They’re under way.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("hangs the shield on the mast.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is at the helm.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Steer. Elpenor, I’ve forgotten, how old are you?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Another quarter moon, sir, I’ll be twenty-two.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Twenty-two! My son’s age. Or, rather, half a son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why half a son, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                   His other half could be you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The croak of that mast. Like a crow, crossing a field.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A tower cracking. Troy, Troy! What was it all worth?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not a crow. More like a sheep that strayed from the fold.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’d give up all this heaving for one yard of earth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll soon see the sunlight wet those homecoming oars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Even monsters on the bottom crawl to their bed.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re as lucky as they are, sir. You’re close to yours.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Islands weary me now. Foam is flecking this head.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A clean white bed is all a man asks for on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("taps the mast.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I think of that olive tree my bed was made from.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aye, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("              And those stars flying. Embers from my hearth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Captain?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("               No night was so long. No dawn more welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Below deck.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Once, it was off Smyrna, I cut a captain’s throat.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like a sheep.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                      Right, he bored me. Kept bleating of home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s his drift, isn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                       Home’s just another threat.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So you’re stuck with killers of sheep, shepherd. Welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("descends from the upper deck with a lantern, tours the crew. Boatswain’s mattock is beating.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("By dawn’s edge, Ithaca. By star-rise, my own roof.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Been how many seasons since you left home, Captain?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Twenty. The sea air smells friendlier.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                Could get rough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When sunrise comes, I’ll give the dawn back her lantern.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("‘Home’! The word that a gull cries over wild waters.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ve a boy I haven’t seen for half of my life.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’ve shot up like pliant saplings, my two daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("For me, home is a breathing death. Back to the wife.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughter.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("These oars multiply the image of what we love.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("For me, home is grey fields with a ploughman’s fire.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sometimes it’s a smell. I’m pierced by the scent of clove.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A grime-streaked angel gesturing from its spire.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("For me, Captain, a reef in the battering surf.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Objects outlast us. Spice tins on a kitchen shelf.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Until he enters his own grave, sir, no man is safe.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then call me ‘No-man’, but your friendship is my wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He climbs back up to the upper deck.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’ve you got from the sea? A fistful of silver.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Or a school of flying fish, scattering like stars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s the sum of it. You live off that forever.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That bag Aeolus gave him. Whatever it was.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’ll be up on that deck for a while. Where’s the bag?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He stuffed it under his bunk.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                  Will he be killed?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s made his fortune, Stavros. No sharing the swag.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s made a pile from the war. Gold cups, coins, that shield.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("I’m going down. Tap three times if he comes.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Upper deck.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, the kings I’ve known, who saw themselves as fixed stars!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What kings, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                            My far comrades at Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                        But their fame?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They were meteors, in their long fall from greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          That sea simplifies them, Elpenor. To foam.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He is peeing over the side.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How can you keep your balance, without tumbling off?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Feet braced. I’m steady, helmsman. It’s those stars that aren’t.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’re swaying like scales. Can you do that when it’s rough?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Stars! Look! the sprinkled urine of the firmament!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Day will break soon. A dawn breeze soothing the mind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Those waves are leaves in my garden …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                      Sounds a nice place.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And on the lawn over which a hunched oak towers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Would you care to sit down, Captain? I’ll make some space.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My stone bench anchored in a foam of white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lightning.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There, sir, through that crack of light on the horizon!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’re just the distant flashes of a summer storm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wait now, sir! Where pronged lightning forks the sea’s garden?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What, boy?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    You knelt there, pruning flower beds of foam.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your watch ends when?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         Sunrise, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                              I’ll believe you if …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("If what, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    If you’ll admit to wine on your breath.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, me and the crew had a jar earlier, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Steer carefully. A cloud can harden to a cliff.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Below deck.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Open the knot.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          There’s nothing in there, just wind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re lying.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                      It’s getting dark suddenly, why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Get up and look again, clod! Up, under, behind!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s that noise? It’s like windmills churning up the sky?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’ve opened the bag. Now the seas are mountainous.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look! White sheep scattering from the fork of that storm!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Something has injured this sea. It’s breaking our oars.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sound of breaking oars.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’re cracking like bones in a dog’s teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                        WATCH THAT STERN!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There’s sunrise. Ithaca! A pink cloud and mountain!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sunrise.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                HARD WITH THAT HELM!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ay! The blue’s turning greener where shallows begin.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("ITHACA, CAPTAIN! LET’S KNEEL DOWN ON DECK! YOU’RE HOME!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("THE HELM, DAMN YOU, BOY! Seagulls, the first fishermen.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The ship lists sharply.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The island is tilting and that white mountain town.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("THE GULLS ARE THROWING THEIR CAPS IN THE AIR, CAPTAIN!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("HOLD ON TO THE BLOODY HELM, BOY, OR WE’LL ALL DROWN!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where is it, Skipper?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                    Home! Poplars! Mount Neriton!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is swept overboard.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("HELMSMAN OVERBOARD, CAPTAIN!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             Where’s Achilles’ shield? Gone?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("CAPTAIN, THAT WAS THE HELMSMAN!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                    WE’RE BLOWING OFF COURSE!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAVROS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You unknotted this wind! We are gone forever.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We’re lost sheep, Stavros.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           ELPENOR! TELEMACHUS!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The ship founders. All hands swept overboard.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE VI")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Cries, gulls or girls playing. A ball bounces across the sand. A girl,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("chases it out of sight. A screech.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("runs back to join")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and another girl,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I seen him, I seen him, the Old Man of the Sea!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, girl, speak properly, and run back for my ball!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Face down embracing the surf; please, please, believe me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You saw a log with arms, don’t get hysterical.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m not hysterical!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                I’ll bet he was naked.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why do you always ruin our games with nonsense?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Beg pardon, Princess.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     She’s just got men in her head.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s all you saw, girl. The dream of your secret sins.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He was spraggled face down like a starfish! Naked!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Maybe a starfish is the Old Man of the Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Or an octopus now, playing ball with eight hands.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why don’t you fetch the ball, if you don’t believe me?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("’Cause she didn’t throw it!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                              A starfish! Without no pants!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears, torn, naked, carrying the ball. The two girls scream and run.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("throws the ball, collapses.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Please get up, sir, don’t lie on my kingdom naked.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The sea has beaten me. My sight’s not too clear.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You should put something on. This is very awkward.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("White cries rose behind these rocks. A wave rolled me here.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, did the reef tear you? What happened to that arm?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I was spun like driftwood by those smoking breakers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s the white, wild side of the island. Here it’s calm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I woke to hear seagulls crying. They were girls’ cries.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There was a wild storm last night, the oaks were groaning.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I survived it. Swinging from a branch like a bat.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Still, after hurricanes there’s the light of morning.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Upside down, over the surf. Hearing the storm beat.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s rough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                       O Nymph, whose freshness is sheer perfection!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sheer? You’ll gain nothing addressing me in that way.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I am dazzled. My salt eyes are scorched by the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s how all these overtures start. With poetry.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What poetry?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                        You know. ‘O Nymph’, and all that business.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I thought I drowned and soared with the gulls to heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("See? Next you’ll croak about clutching my shining knees.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I will?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Why not just say it?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pause.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                              Or think it, even?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("      Or talk about my eyes, like sea-green shallows.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes. They are. You’re right.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                              Or the pink shells of my ears?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nymph, I’ll say no more than my nakedness allows.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          Because there’s a huge gulf between us, girl. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Years!")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t bark at me like some seal! You know what you are?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("      A snarling, whiskered seal sunning on some reef.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She mimics a seal.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, am I?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 Blaming me for your catastrophe.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re well on your way to being somebody’s wife.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yours?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            No. I’m too old. Plus, I have one already.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Too old, with that panelled body? Old is like this.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Crouches, clutching her back.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re an old man’s delight.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                               Shall we meet properly?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Shall we?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                Nausicaa. And you’re my gift from the seas!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She kisses his cheek. A roar.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s that noise in the throat of those hills?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                              Oh. The games.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The games? What games?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  You’ll see. When I get you some clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ve heard that cheering echo. Spears, hoisting dead names.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re in tears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         More salt. For Elpenor. Troy’s heroes.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He stops. Listens.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Were you a hero, too? Why are you stopping? Move.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Every fuming breaker brings echoes of that war.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What war?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   Exactly.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 It took you from those you love?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Twenty years now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 Come. You’ll tell it to my father.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They climb.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who’s he, your father?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                       He’s the king of this place.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I lost ship, crew, a shield. I have nothing left.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We’ll find them, I promise. I’m a real princess.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I could tell.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    Liar.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                            I could. From the way you laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("peer out, stop, advance.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("walks ahead of")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The map of the world’s on your back. The skin’s peeling.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sun and salt. For ten long years. What are your friends’ names?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Girls. This is Scheria, an isle known for healing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("By three gracious spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           And famous for its games.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Distant cheering, louder. They exit.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE VII")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Alcinous’ palace.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHLETES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COURTIERS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exercising. Music. Trumpets. Cheering.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("steps on to a platform. Drums and horns.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("as")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sings")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Fleet the bare feet of runners racing on the sand!")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Their ankles whirr like hummingbirds towards the laurel.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Extending their arms like swallows as they reach the end,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Their thighs are blurred ovals passing breakers of coral.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What greater glory than what men win on their feet,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Outdistancing friendly shadows in their short sun?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Greater than poetry is the metre of the athlete")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Since their glory is brief, and swifter than any song.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They turn into birds, they are stretching to leave the earth,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("They’re pliant as otters, their heads sleek from the surf.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But let them stay green as the Olympian laurel")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("In the kindest of wars, the games, man’s happiest quarrel.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Kindle the torch, begin these Phaeacian games,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then, on plaques of gold, silver and bronze incise their names.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("First let us honour this shipwrecked stranger, our guest.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Roar.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Thanks, gentle Scherians. I’m enjoying it here.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In a while the games. He has accepted our test.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughter. Some booing.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, I’m a bit rusty. You’ve every right to jeer.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters the ring. Takes javelin, hurls it out of sight.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That could nail an eagle. Out o’ sight, man, out o’ sight!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Here comes the runt now, he’s shorter than the spear.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bet you he puts out the sun’s eye, turns day to night.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bet you it drops like a swallow, tired of air.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("hurls his javelin farther.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Knock me down with a feather! That’s gone to Egypt!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FOURTH COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Send an expedition to find it. Heard that hum?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It sang like a swallow, man!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                He’s lucky. It slipped.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FOURTH COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yeah? You slip over to Egypt and bring it home.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("confronts a")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YOUNG ATHLETE. ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YOUNG ATHLETE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("wrestle.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("lets himself be thrown.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I stopped because I imagined you were my son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YOUNG ATHLETE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s a good one, I never heard that one before.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I couldn’t hurt you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YOUNG ATHLETE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  Try, you have my permission.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("throws him, pins him.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I keep seeing him. Telemachus. Elpenor.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Cheering.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("calls for silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You see here a man who’s lost all his worldly goods.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("General groan of sympathy.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who the sea-god hates, but who’s survived every storm.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Applause.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like a boar dodging the lightning-lances of gods.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Imitates a boar. Laughter.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A wanderer who knows your bounty will help him home.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("If you were simple men, I would tell you such things …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FOURTH COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We live on islands. We might believe them, try us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You are polished, sceptical men. My wanderings …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIFTH COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("       Men used to hearing the surf curl in their ears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The more outlandish your tales, the more they’ll please us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My father loves stories, he rewards their singers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Devious Odysseus, divisive Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Did you know him?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  In Troy, that’s what he was known as.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Troy’s wind has touched every island with its ashes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll do well singing about him, eh, Phemius?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You know his stories?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      That liar Odysseus?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tell us his stories, stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                               In a sailor’s prose?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("As blind as he is, he’ll stitch them into one song.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His lines can hum like a succession of arrows.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Or combers that crest from the shale, horizon-long.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They are like huge oars lifting, the heft of his lines.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Thudding like lances on to the heart of this earth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He baffles augurs. He can hear the bird’s designs.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He can smell the smoke of Troy, and that’s far enough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He can feel the truth. The way blind men sense the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What lasts is what’s crooked. The devious man survives.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why’d you say that, Phemius? Because you’re blind?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s the way with tears. Crooked streams join their rivers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why has it taken so long to reach your kingdom?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ve found no mercy from the sea, make this your shore.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No wanderer ever had a warmer welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tell us his enchantments.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                            You’ve heard of Calypso?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LISTENERS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her marble arms entombed him for seven years.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What kind of a woman was she? I know. Soft, but stern.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Odysseus couldn’t recognize Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Most women who look like statues have hearts of stone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Foam girdles the waist of her island with white lace.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nausicaa’s blushing, look.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             I’m not. Don’t stop for me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s Atlas’ daughter. What do they call the place?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like her dimpled white mound: the Navel of the Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Return us to her island. Now that you’re healing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A cave’s blue entrance: alabaster, porphyry.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m sealing my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  Waves of light on its ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I hear a spring chuckling like a woman, softly.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re too young for all of this, you’ve imagined enough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, let her learn not to exploit her innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Two bodies tangled in linen as white as surf.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("O Nymph, let your freshness salt and cure all my sins!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Was enchantment hidden in the island itself?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In her and the island. One cleft of flesh, one of stone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Soon I’ll have the power to make grown men dissolve.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Girl!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("        They claim she tames fierce creatures, not men alone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("Lions purr under her palm, wolves flatten their ears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("And those wild beasts prowled the door of light from her cave?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They growled when thoughts of home clouded Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But didn’t he find delight in her happy grave?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. He sank into a sadness no flesh could cure.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sadness?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                Longing for his island. She heard him weep.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Even while she oiled his body and brushed his hair?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Leopards with lantern-eyes guarded their sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now she adores a mortal. Unhappy goddess!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So she helps him build a tree-raft, fastened with vines.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He leaves?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                  He leaves one dawn, when clouds open their doors.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Our bodies long for their far shore, this raft of veins.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yet he stayed there, cloud-pillowed, for seven years her guest.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How could a mere mortal break from immortal arms?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Because that beach was shadowed by another’s ghost.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Whose?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("              His wife’s. The raft is ready. That moment comes.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          The goddess offers godhead. He refuses.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He declines immortality? God! Tell us why!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He longs for his own rock, too stony for horses.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Over heaven?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                        It seemed natural. Men love, then die.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But his name, Odysseus, rivetted in stars!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He prefers to kindle the lamps of his own house.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And that house will be the lamp by which his raft steers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Monsters, more monsters! Let’s have monster stories.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You beg for what he’d rather forget. Well. Monsters.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tonight you’ll curl in clean linen, the shell of sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll smell rain in the earth, and when the hillsides shine")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll see purple vineyards laddering every slope.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then, our marriage-cart, drawn by nodding white oxen.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughing")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Whoa! Whoa! Not so fast! You deserve a good husband.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There’s a ‘but’?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          How’ll I explain it to my wife?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughter.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tell her you met me and were swept overboard and …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s true.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   Wouldn’t she be happy that I saved your life?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s a smart girl but a bit too fresh for her age.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Goddesses can be so vulgar! Caves made of gems!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Listen, poet, and let your eyes seal each image.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Remember you heard them at the Phaeacian games.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sir, the truths I will tell are too full of horrors.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We idle in the sun. We never have nightmares.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let’s all move to another room to hear these stories.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Some might redden the innocent shells of her ears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, please, please, begin your stories! You’ve a lot to gain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then imagine an iron island. Sunless. Cold.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m shivering.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                        The future is where we begin.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is this just a dream?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                   No. A place where dreams are killed.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("All exit, except")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("still as")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and three")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COURTIERS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You can build a heavy-beamed poem out of this.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It will ride time to unknown archipelagoes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHEMIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I heard that voice at Troy. This is Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD COURTIER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why lie about it? Natural cunning, I suppose.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They exit.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MARTIAL CHORUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Off")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To die for the eye is best, it’s the greatest glory:")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Dulce et decorum est pro patria mori.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There is no I after the eye, no more history,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Except his own, Odysseus. This was his first story:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A sea, like lead, heavy as time’s weight in water,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("And a sullen harbour, eternally overcast.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not a seabird beating, a thousand years in the future,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Time, altering the bodies where they were encased.")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A long, grey, empty wharf. A sheep’s carcass, gutted, hanging from a pole. An oil drum rolls on, chased by the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("who rummages in the contents of the drum.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS, EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and two")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enter.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This is frightening, sir. What kind of city is this?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like one long Sabbath, an infinite, empty wharf.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("runs towards them.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("History’s repeated! A second Odysseus!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Stop!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("         Wanderer, you’ll need advice.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                             Listen, buzz off!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They praised you once, Odysseus, forbidden phantom!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sir, none of my virtues is nobler than all men’s.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, now you hear to what quiet a country can come.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Apart from this bleating of sheep herded in pens.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sir, everywhere there’s the sign of this giant eye!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A man becomes nothing at that Zero’s bidding.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is this the Greece that I loved? Is this my city?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Philosophy’s cradle, where Thought is forbidden.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Can I see the Eye?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                No, rather the Eye sees us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The Eye’s their shepherd, and the nation are his sheep?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Return to that age of heroes, Odysseus!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’d like to see this monster. Does it ever weep?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("      And the wall?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                              Erected to keep us in pens.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So this city is nothing but a giant cave?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With History erased, there’s just the present tense.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I breach walls.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         For a freedom that men dare not crave?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Distant sound of a parade over the roofs of the city. Sings along.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Listen.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What to the eye is best, the greatest glory?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Dulce et decorum est – to die for a lie with zest –")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Pro patria mori.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There is no art, no theatre, no circuses even?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This is the era of the grey colonels. Grey rain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So one cold eye is all these Greeks know of heaven?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their statues weep with grime over history’s ruin.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("EURYLOCHUS, SHAKE ME! WAKE ME UP FROM THIS DREAM!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sound of a huge door closing.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The cave is blocked. We can’t leave, Captain Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The future happens. No matter how much we scream.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sound of boots over cobbles, two")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PATROLMEN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in sheepskin coats enter, carrying chains.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The Eye has found us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                       Bay! Obey! Do what it says.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST PATROLMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Do not talk to this one. He has slandered the Eye.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My turn has come.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND PATROLMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 By the way, what is your name, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is seized.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My name is Socrates Aristotle Lucretius. Philosopher.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He is marched up against a wall, clubbed, then held upright.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST PATROLMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Lower your heads, you sheep! The Great Shepherd is here.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The door opens and the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("slowly approaches. Sound of cheering crowds, distantly.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PHILOSOPHER")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Recites")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yet I was one among many thousands in the square,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("But always too late, too far at the back to see")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The smiles of the tiny faces on the balcony.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Those in front with the caps, braids and medals, and those at the rear")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In coats and identical hats who didn’t wave")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Like the central one, turning both profiles repeatedly")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Into a coin or a postage stamp. I had to be there")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("With the roaring victims who craned or held up children")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And yelped and jumped high like dogs that you are training")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("In that boxed, crammed square that felt like a mass grave")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To a drifting smell of formaldehyde or adrenaline,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Learn what I remember, that someday it could save.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But I swear, on my grave, now that it’s all over,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And the square and the balcony empty, I was there, but I didn’t wave.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PATROLMEN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("remove him.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let the Greeks remember Odysseus the Brave!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("faces")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t stare.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sorry.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What is your name?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where’re you from?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nodding")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where’re you going?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("From nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Going where he doesn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Normal.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What do you believe in?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nothing. For now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not the Great Eye?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughing")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not yet?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Nyet.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why not yet?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t know you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I see all.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Everything.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You believe I see all?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You don’t see anybody.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I see you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughing")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So you said.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All you see is nobody and nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The Eye likes you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The ugliest thing is a liar. So you’re really ugly, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Noooh?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How ugly am I?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("dances.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Man, you so ugly nobody would believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Except you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Black accent")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m nobody, dude. You’re "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("ugly,")]), _vm._v(" I believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Roaring with laughter")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("God, what accent is that? I’m going to die.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh, you will, you will, boss.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Weeping with laughter")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                Stop, you’re making me cry.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Laughter and tears, right? Pouring from the one eye.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m exhausted. You’re funny. I’ll see you again.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not if I see you first, man.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             You’re a killer, Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughing")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not as much as you, my man.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re coming to dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I thought I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("was")]), _vm._v(" dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits, roaring with laughter.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and the two")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("get up and join")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What do we do now? Think, Captain Odysseus!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You must have some ideas: you’re famous for scheming.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let me think, let me think. There’s some way out of this.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’re coming back. Oh God! Let us all be dreaming!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PATROLMEN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("return.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Come on, then. They need us. Don’t whimper, don’t bend.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Generations of men, like seeds flung on the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("obstructs a")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PATROLMAN")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Listen, the Cyclops likes me, sir, I’m his good friend.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Oh God, sir! Oh God, please, Captain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                   Leave him behind!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are removed.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE IX")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A dinner table. Night.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("eating, attended by")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RAM")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("a manservant.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Know what you’re eating? Your men. As good as sheep.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("pauses, eats.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And you know what they call these drops from my eyes? Tears.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He stops eating.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My eyes cloud when I laugh. You must teach me to weep.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, first you must lose things you loved.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                        Then cry, like this?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He squeezes his eye shut.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not quite.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Opening his eye")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 I like laughing. Make me laugh, little man.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Make you laugh. All right. Know why I can cross my eyes?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He crosses his eyes.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Giggling")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 God gave us two eyes because we’re human.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m not.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("              One is for laughter, the other one cries.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Do it. Show me. Ram, come here. Take a look at this.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("makes a funny face.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RAM")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("comes forward.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RAM")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Very good, sir. Nobody I know can do it.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He resumes his position.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I love Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          Same here. Nobody loves you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look! Why do you need two eyes? One does just as well.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("For balance. Proportion. Contrast. Mortals need two.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’m a demi-god.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                             Left, right. Good, bad. Heaven, hell.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I have deified myself. Son of Poseidon.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I know your father, the sea. He doesn’t like me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why? I’ll talk to him.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     Gods! Who knows what side they’re on?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s rough-tempered most times, but he can act calmly.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Put in a good word, then. I’m trying to get home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Home. You’re home now.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                            Well, this wasn’t quite my idea.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Silence.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not your idea? There’re no ideas in this kingdom.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ve a wife, you see. Like my eyes. We make one pair.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where’s that, my little friend? Tell me where you come from.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A rock, too stony for horses. With swirling shores…")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What flocks do you have? Goats, sheep? Is it a kingdom?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("       And are you its king?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             Yes. But it’s not like yours.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In what way?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                       Its subjects don’t end up on skewers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laughs")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like your men, you mean?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                               Right.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                          How many’ve I eaten?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Of my crew? Just two. I suppose, before them, scores.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They’re tenderized by tortures, the flesh is beaten.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("While your sheep bleat in fear of their devourer.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But I’m saving you for last.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                               Well, that’s very kind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   Two of my crew, and one philosopher.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("picks his teeth.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Spits")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is this him?")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                     No more ideas. The last of his kind.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("holds the skewer over the flame.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look how this little iron lance glows at the tip!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Stick it in the meat.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("drops the skewer.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                  Too hot.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                 Ram, get a clean one.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("searches on his knees for the skewer, hiding it.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, no, no, it’s all right, really. I’ll pick it up.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ram, a clean skewer!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("From under the table")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      No, really.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                        LEAVE IT ALONE!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RAM")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("on his knees looking, gets near the door.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That’s the way I am, sorry. I hate losing things.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("GET OFF YOUR KNEES!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     My men, my money. My way home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your life next.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         That I don’t mind. Just hate losing things.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Searching, on his knees")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ll help you look.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                               That’s three eyes, fine. Where did it go?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It couldn’t have gone far. And Ram will be back soon.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I give up. But I hate to. One thing you should know.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s that?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                      The sky goes pitch black when there is no moon.")]), _vm._v(" "), _c('p', {
    staticClass: "exvs"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He crawls near the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("takes out the skewer, blinds him.")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Blackout. Sirens moaning.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("NOBODY HAS ESCAPED, NOBODY BLINDED ME!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LOUDSPEAKER")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("REPEAT, NO ONE HAS ESCAPED. KEEP LOOKING FOR HIM.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("NOBODY’S ESCAPED, NOBODY’S BLINDED THE EYE.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("NOBODY, YOU HEAR ME? NOBODY IS HIS NAME!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shouts back")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("SON OF POSEIDON! YOU OBSCENE OCTOPUS!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("YOU TON OF SQUID-SHIT, WITH YOUR EYE POURING BLACK INK!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("MY NAME IS NOT NOBODY! IT’S ODYSSEUS!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("AND LEARN, YOU BLOODY TYRANTS, THAT MEN CAN STILL THINK!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sirens moan. The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("picks up an oil drum and hurls it at the retreating")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("screaming.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE X")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Circe’s island. A beach. Rich wild plantains. Some of the crew lolling. A")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("WOMAN")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("playing a drum.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enter.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Circle the graves of our bodies, traveller. Pass.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("crouches near a")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILOR")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sailor, this sudden indifference, where’s it from?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That red flower nodding agreement with the grass.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A sleeping sickness. They were felled by its perfume.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You went ashore for fresh water! Back to the ship!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The island has drugged them. They’ve no will to go on.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their heads hang like sunflowers.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He shakes a")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILOR")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                           Tell the sea to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Here the lion takes a whole afternoon to yawn.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Join us, Captain. Watching you stand makes us tired.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What have you eaten? What changed you? What is this place?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This place? An island that has all you desired.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’s the falls.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                     What?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 That waterfall, thundering peace.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Could its veils bind their limbs like this?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                       And mine.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("shoves")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                                  Move! Move!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Although my longing for home is as strong as theirs.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Captain, keep moving.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("slides down.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                        So great … this burden called love.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("lifts")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Up! Up!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("               Yield like a lily to the weight of years.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All forms of love are meaningless except self-love.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who did this?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THE WOMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          Circe.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     Don’t breathe, Captain. What’s the rush?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The grave is coming towards us. No need to move.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The grave we all come from was hidden by a bush.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then Doubt went into labour and produced Reason.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What is in this weed that makes fools philosophers?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My head’s clearing now. Like a mist burnt by the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All right, men. Back to the ship. It’s waiting for us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Flowers, like fire.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                              Try, sailor. How do you feel?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In a different archipelago. But the same.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They worship the elements. They kneel like you kneel.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Each god has his earthen root.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                     Just a different name.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their gods quarrel like ours and hurl meteors.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They sacrifice oxen. Drink their blood from clay bowls.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They spin, possessed, around delirious altars.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIRD SAILOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then wound the earth and descend to the place of souls.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Music.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("REVELLERS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enter, with animal masks, singing.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHORUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sings")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aeaea")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aeaea")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aeaea")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ai-ya-yi")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My emerald island")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Between blue sea, and blue sky")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The island of Calypso")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Aeaea")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ai-ee-o")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Bacchanal")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And carnival")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is the place to go")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("O Lord have mercy")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Before I dead")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let me lie down with Miss Circe")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Stroking me head")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Stroking me bald head")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That have only one eye")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When she stops")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("See me Cyclops")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Falling down dead")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("O Lord have mercy")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("On all me sins, is true")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But when Circe spell fell on me")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I turn beast too.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears on a palanquin, carried by pig-headed")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BEARERS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Circe have mercy")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Make me turn beast too.")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE XI")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Red decor.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in her brothel, with")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SAILORS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in the form of pig-men, and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("GIRLS. BILLY BLUE, ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enter.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Madame, we’d like our crew back.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                           With your permission.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ever seen this before?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      Not quite.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                       You like watching?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not my men.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                       You see men? Sorry. Semen. I see swine.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She laughs.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This powerful weed metamorphosizes men.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The inner animal erupts through their features.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her black locks pouring like a golden lion’s mane.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Spines bristle their backs, they have little obscene eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But what they become is for what their natures yearned.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She strolls among the creatures, poking them with her wand.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("walk through the crowd. Grunts, screeches, off.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her music’s pounding with the odours of rutting.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Perfumes won’t dispel it.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Her rooms are grunting pens.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Still, give it to our enchantress, she knows one thing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            That brothels aren’t just sailors’ dreams, but all men’s.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not mine.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   All.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         Don’t yield, sir, you have a wife and son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("At the back of all men’s minds is a rented room.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her hatred can be dispelled. She thinks men are swine.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We create our own features. Not her. We change form.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears, offers a flower, blocks")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wait. Chew this milky flower. They call it moly.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What is its power?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 Chew it, you’re out of her range.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where did you find it? It’s streaked. The sap looks milky.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In a speckled grove. Gods know it. Chew it, or change.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Have you eaten it?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                Not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                              Will it work?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                     Yes, yes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look, it may be great to be a pig for a change.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With grunts for a language, a screw prick, bristling ears?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chews")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Cheers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("             Here comes our hostess with her fatal hors d’oeuvres.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("approaches.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Have you had one of these yet? They’re lovely with wine.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, they look lovely. Your own little endeavours?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My own little hands.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Claps her hands.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("               NOW, BACK TO YOUR STIES, YOU SWINE!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She herds the pig-men off, then takes")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v("’ "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("hand.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where’re we going, madame, and what about my friend?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let him find his own diversions. Rent his own room.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This is for the crew’s sake.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             We won’t be hard to find.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But where?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    Where, except down a woman’s path? Perfume.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exit, two")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("GIRLS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("accost")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s up, Mr Gentleman? Look a little lost.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How you feelin’, sailor? What’s this in your pocket?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t care to be accosted, thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                  No cost.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("searches his clothes.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What are you feeling for in your pocket?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                       It’s gone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You lost it?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    A flower.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                    Let me pick it.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She fondles")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("while the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST GIRL")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("forces a drink down his throat. They step back.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("changes into a pig. They laugh, chase, catch him, one rides him, the other puts a garland around his neck and drags him off squealing.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE XII")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Interior.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("prepares Odysseus’ drink, slipping in a powder. He chews the moly-flower.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sings")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She give him shining bush to drink, she give him man-you-must")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She fix him a liqueur of gooseberry wine")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But his flag still at half mast")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She pour in some sweet-oil and crush it with thyme")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Coriander, basil and cerasee")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But the flower of the moly slowly defy she")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Power of matrimony")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, no, doux-doux")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I have a message for you")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("As sweet as you are")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And you sweeter than guava jam")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I have a wife at home")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And she begging me come")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And I saving it all for she.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("sips the potion.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is undressing slowly.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I have a wife at home")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And she begging me come")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And I saving it all for she.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She slip off she shoulder strap, she raise up she hem")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She untangle she jewellery")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All the time she keeping her big black eyes on him")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Circe circling him for some revelry")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With lavender, rosewater and cerasee")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But the moly slowly, slowly strengthening him")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He thinking as he drinking")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No, no, doux-doux")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I have a message for you")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("As fresh as you are")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And you sweeter than sugar-plum")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I have a wife at home")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And she begging me come")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So I saving it all for she.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Become this man to whom everything has happened.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What I want is so simple. To reach my own bed.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll learn more than the others. The swine I keep penned.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What would I learn from this?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                     From a goddess? Godhead.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But taking what form if not a man’s any more?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My nostrils flared the minute I saw you enter.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Your head lifted. A stallion circling his mare.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With your season on the wind?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                       Circling. Thudding her.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This stallion’s married.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("strokes his thigh.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                        What did this?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                  Boar. Hunting scar.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Hunt mine. We’re kindred spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                            Yes?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                    You know we are.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not kindred bodies. This pig-scarred adventurer.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Reason has never restrained you, Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters, disguised as a maid.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We have company.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 She’s young. You’d like to try her?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("As well? Too exhausting.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Go about your business!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Madame, I’m sure this could be a night well spent.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re in your house. A house men’s desires built.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Paradoxes in brothels. Why’s this different?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Deceit without sadness.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         Only swine feel no guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When heaven flares from the charge of our joined bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Your spasm’s force need not bring oblivion.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And my wife?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         My cold lips will be Penelope’s.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ah!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("       We’ll re-create the gendering of your son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No ‘home’ and no mercy. The white harbour. The heat.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("lifts the bedsheet.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("After rough seas, rest. From this tangled linen, calm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("To lie on my olive-tree bed, sun crossing its sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Rest your head on the length of this ebony arm.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She licks his body and rolls over. They make love, then sleep.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters as a servant. She draws a circle around their bed, sprinkling it with flour, hides.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("leaps up.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What’s wrong? You just leapt out of bed like a whirlwind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Someone was here.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She rises, paces, distracted.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                 The sheets are all soaked with your sweat.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I heard: ‘You’re a monstrous bitch. You’ll pay in the end.’")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           A green-eyed goddess. You’re her favourite.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who was she?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         She sprinkled it round this bed. White sand.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tasting it")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’s not sand, it’s flour.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      That girl crept back in here.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You heard her whisper something? I didn’t hear a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We’re ringed by an owl’s cold eye. Death is its centre.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The forest is thick with branches where wild owls brood.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And they are her heralds. Maman de l’Eau. Athena.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re cold as a corpse.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                         A vision has iced my blood.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then change my men back.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                A white owl with lids of stone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So, an owl flew in. Not all owls are an omen.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She hides in a waterfall’s cascading curtain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Maybe she wants you to turn your swine back to men.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her words kept bubbling like a pool’s cold basin.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Muttering nonsense.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                    That you were her chosen man.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What about my men?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      Remorse will change them from swine.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She huddles in a corner, moaning.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t huddle there like a little girl, please; don’t moan.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A RIVER OF FIRE, A RIVER OF LAMENTATION!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wake up! You were dreaming.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                     You must go down to hell.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Child! Hell is the shadow of imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Points to the window-curtain billowing.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look! Look at that curtain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                Now it lifts like a sail.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("looks under a pillow for a pack of cards, spreads them, holds one up in fear.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Let me trace your palm’s rivers. Sit; open to me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t believe in that hoodoo, or in this card.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He shows his palm.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("reads it.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A cock to Shango or sombre Persephone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Some plumed rooster like Ajax strutting in your yard?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("kisses him.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Love, in this world where my body was your compass.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where I’ve spun for twenty years without my true north.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Enter the magnetic earth through which our souls pass.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          Eternity’s lost. My mouth leeched to your mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She kisses him again.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Suppose it wasn’t prophecy but a bad dream?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("      You’re trembling. Come, I’ll lift the cloud of your hair.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I saw black Acheron fuming, that stinking stream.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But those who cross to its bank can go no farther.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their faces will turn to meet yours. Enemy, friend.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I shall greet the dead?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                      Dig this trench. Long as your arm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’re mad!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                     You’ll see a blind man shawled in a black wind.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I thought only pigs saw the wind. In your pig farm.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You’ll sprinkle this raw trench with wild barley and milk.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Persephone’s rites. You know what my nightmare was?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            To drown in this oblivion of scented silk.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He yanks off the sheets.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Drown? Didn’t the rustle of linen please your ears?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Carried far from my coast on pillows of lace-foam.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He tears open the pillows.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go home, then!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Barking")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yap, yap! Licking your feet like a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Finished?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 Clicking your fingers. ‘Come when I say “Come!”’")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("But I loved you, my pet.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           Good. Unleash him. Your dog.")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A yard.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DRUMMERS, SHANGO DANCERS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in white, with candles, a sacrificial rooster swung by the neck as a circle of chalk is drawn on the ground by")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PRIESTS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in an admiral’s uniform under his great-coat, is given a sceptre and a wooden sword, as")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("leads him to the centre of the chalk circle.")])]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CELEBRANTS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chanting, dancing")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Shango")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Zeus")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who see us")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Man go")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Name Odysseus")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go down")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go down")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ogun")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Erzulie")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go down to hell")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sprinkle water")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Erzulie")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Athena")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Maman d’l’Eau")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("River Daughter")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Shango")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Zeus")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All who see us.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Your soundless sword will divide not only the air.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Severing this world of light from one past knowing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where buried Persephone glides for half the year.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Till helmets of gold crocuses shoot with the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("As this blade divides the world from the underworld.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So the hairline of one breath keeps body from soul.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("O world halved by absence, by Time’s exacting sword!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("While both worlds keep yearning to make each other whole.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go, where the chosen of gods alone can enter.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SECOND SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This crack in the heart-broken earth, here you descend.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tell green-eyed Athena I’ll never offend her.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And my crew?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          Restored. Our life ends in a black wind.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("’ eyes are wrapped in a black cloth.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You dig a trench. This long. ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Showing an arm.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                You must wound the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With what?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                     This sword. It’ll open. A woman stands there.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           A phantom on a platform. An iron sound.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sound of huge door opening.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIRST SHANGO PRIEST")])]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("Earth’s stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                             A widowed phantom. Your dead mother.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("In tears")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You swine!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He swings the wooden sword.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                    To see her, enter this divided stone …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why this heart-breaking vision? Why not another?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A station, echoing arches. And her, alone.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("draws an ‘L’ on the earth. The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CELEBRANTS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("withdraw. The earth opens.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENE XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "exvb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Underground.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("removes his bandage, enters the turnstile. A machine with a mirror. Then, behind him, a woman in a coat, hat and scarf: his mother,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is it running late? These days they’ve been running late.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Don’t you recognize me?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                            Who are you?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                    Mama, I’m your son.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Odysseus? You’re now one of our bodiless freight?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. I’m not dead. Now I pray that I will be soon.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, one’s no worse than the other.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                        When I look in a mirror …")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yes?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("        I see the skin wrinkling at my throat now; like yours.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("If I looked in a mirror there’d be nothing there.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not the ‘you’ that I find in me over the years?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is that how I smiled? Did I toss my chin like that?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Every mirror echoes it. Your mannerisms.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Including this one? ‘Boy, I’ll give you a big clout.’")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She pretends to strike him, smiling.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My tears multiply you as if they were prisms.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He weeps.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Why’re you here alone? Why’re you waiting around?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’s my station. Under the bed of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How many more stations are there in the Underground?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You never get off. The train goes on forever.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("as a blind vagrant with his guitar, belongings and a stick, stops and puts out a palm.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Two coins for these white eyes, sir, and I’ll prophesy.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("You live here?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                         Correct. Sleep most nights under the bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Homeless?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   No more than you, sir. So far as I see.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How far’s that?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          The future.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shrugging")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("              Your priv’lege.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I’ve no money. Time has broken me at great cost.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Yeah, but the word ‘home’ swirls in the caves of your ears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Grief added to my fortune the mother I lost.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Just give him one coin. He hustles his prophecies.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A train flashes past.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("pays")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE. TIRESIAS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enters.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My comrades screamed in the window behind the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Right. Heard what they were saying?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                No. Not a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They were the open mouths of your crew. More will pass.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When do they stop?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Their station. Wherever they sinned.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("appears on the opposite platform, in a midshipman’s uniform, with a bag, his head bandaged.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There, across these, what are these?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                              Tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                           I’ll talk to him.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I couldn’t bear to face you. I’m sorry, Captain.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Dear boy, my other son! I still haven’t reached home.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wait, he’s on the other platform, it’s not your turn.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I got drunk. I fell. The blades of the propeller.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Elpenor, you precede me, but I’ll come over.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No! No, sir, not yet. Forgive that drunken error!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A train arrives.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("walks quickly towards it, not turning.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then his body swirled away from us like an oar.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In that alphabet of souls, Ajax to Zeus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This ‘O’ will be nothing that is Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. Your house waits beyond the foam-shouldering seas.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Make it two coins. Two eyes for the fate of others.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("pays a coin.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("passes.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Thersites?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 Yes. His useless sword on one shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Didn’t he find peace?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     Too much. His true home was war.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All his exploits forgotten, this rusted soldier?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’ll reach for his wife from boredom and fall on her.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("strides past, visored.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shouts")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("AJAX!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("            He will not turn or unvisor his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He will, for me.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                           His gaze scorches on what it falls.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Great heart, are you still sullen that you lost that prize?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("stops, turns, lifts his visor.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           Achilles’ shield! It’s drowned!")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("turns, continues.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                               If that’s how he feels.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Even in hell he cuts inferior shadows.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He always strode as if earth were dung to his heels.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("crosses, bleeding, in a net.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This one?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                 Towered on his mound, mourning Achilles.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Agamemnon?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                          His was the saddest of their fates.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("God, look how he writhes in a net! Gaffed. A clubbed shark.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His own wife did that to him. You see how he fights?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Visions can blind you. Better to grope through the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Earth has its joys, though all those joys are above us.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ACHILLES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("runs past, helmeted, in light.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Achilles, lightly leaping through asphodel fields.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’s happy that his son survived war’s victories.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like a stag in spring, kicking flowers from its heels.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Lucky father.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ACHILLES")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exits.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                       Don’t blame Troy on one fickle wife.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She was its cause, not its root. You’re under a field.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where Time stalks circling with his remorseless scythe.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Weeding graves for generations, his sack is filled.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Being the determined gardener that he is.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("With brown pods of helmets, dried ferns of warriors.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Flower-eyed Nausicaas and bristling Thersites.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Raking in those leaves that autumn held in arrears.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He felled me on earth, a tree with crippled branches.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Couldn’t he have spared you a few extra leaves?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                                                   Why?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We don’t understand this rage of life for answers.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Questions are in our nature.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                                  Then end naturally.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Look through that tangled rigging of roots above you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Through that crack of sunlight left by the sliding dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A figure, whose sorrow is to blindly love you.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("From dawn to the moon’s white motion. Can you still doubt?")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Roots dangle, then a shaft of light.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("No. There through those roots that let in the light of earth.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A woman sobbing under olive trees, alone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Wait, till the leaves shift.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                           I can’t see clearly enough.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("          Unh!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                   Your wife.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                     Each tear thuds my chest like a stone.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Son…")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("           How many seas before my sail slides its mast?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("More islands, more trials.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v1"
  }, [_vm._v("                                             And more years. I’m still hers?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("There isn’t a rock on your own coast more steadfast.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Even though a long absence has earned her divorce?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Like a bridal rock she veils and unveils herself.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s still besieged like Troy by those roaring suitors.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’s a rare vase, out of a cat’s reach, on its shelf.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("One day his leaping claws could snatch her. Antinous!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She’d rather hurl herself and be smashed to pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And the others? Telemachus? And my old nurse?")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Plough the sea’s furrows to reach them, Odysseus.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And you’ll sit on your bench with leaves like the ocean,")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Under the magnanimity of a broad oak,")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Dispensing justice there, rewarding devotion,")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Till the bright sea darkens your life’s concluding arc.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("fading.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Grey age will creep through your body like the grey sea.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I want to die, to hold you again, my mother!")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Blessed is the storm-tossed heart that ends tranquilly.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("One breath divides you from her who’s already here.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Now I shall fade like an oak leaf in your garden,")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A stone bench in the oaks, watching your hedges foam.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Merciless Poseidon will grant you his pardon.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Elpenor saw all this, through a crack in the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "exv"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Trains flash past. Thunder. The sea.")]), _vm._v(")")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed11cd74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 78
// module chunks = 0